"use client";

import { cn } from "@/lib/utils";
import React from "react";

interface LoveProps {
    isLove?: boolean;
    onClick?: ( e: React.MouseEvent<HTMLDivElement> ) => void;
    className?: string;
}

/**
 * Love 收藏组件
 * 支持点击事件处理和自定义样式
 */
export const Love = ( { isLove, onClick, className }: LoveProps ) => {
    return (
        <div
            onClick={( e ) => {
                if ( onClick ) {
                    e.stopPropagation();
                    onClick( e );
                }
            }}
            className={cn(
                "cursor-pointer transition-transform size-5 active:scale-90 flex items-center justify-center",
                className,
            )}
        >
            {isLove
                ? (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                    >
                        <path
                            d="M7.87239 0.458728C7.58315 -0.154727 6.70968 -0.152552 6.42349 0.462335L4.87976 3.77919C4.76678 4.02193 4.53986 4.19206 4.27518 4.23246L0.68016 4.7812C0.0371507 4.87935 -0.226164 5.66307 0.227136 6.12956L2.88621 8.86601C3.06352 9.04847 3.14346 9.30439 3.10154 9.55533L2.48141 13.2678C2.37076 13.9302 3.07629 14.4259 3.66198 14.0972L6.75263 12.3629C6.99578 12.2264 7.29242 12.2264 7.53557 12.3628L10.6296 14.0987C11.2149 14.4271 11.92 13.9323 11.8102 13.2702L11.1941 9.55439C11.1526 9.30397 11.2324 9.0487 11.4091 8.86651L14.0654 6.12817C14.5179 5.66174 14.2549 4.879 13.6125 4.78042L10.0419 4.23236C9.77887 4.19199 9.55313 4.02348 9.43965 3.7828L7.87239 0.458728Z"
                            fill="var(--semantic-brand-support-3)"
                        />
                    </svg>
                )
                : (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                    >
                        <path
                            d="M7.17786 0.756836C7.17983 0.758067 7.1819 0.759714 7.18372 0.761719C7.18562 0.763869 7.18988 0.768615 7.19446 0.77832L8.76086 4.10254C8.9807 4.5688 9.41836 4.89535 9.92786 4.97363L13.4991 5.52148C13.516 5.52413 13.5213 5.52924 13.5236 5.53125C13.528 5.53514 13.5341 5.54337 13.5382 5.55566C13.5422 5.56758 13.5423 5.57722 13.5411 5.58301C13.5405 5.58598 13.5396 5.59393 13.5275 5.60645L10.8712 8.34473C10.5289 8.69766 10.3739 9.19167 10.4542 9.67676L11.0704 13.3926C11.0721 13.4028 11.0717 13.4092 11.0714 13.4121C11.071 13.4149 11.0704 13.4177 11.0695 13.4199C11.0671 13.4251 11.0612 13.4345 11.0499 13.4424C11.0387 13.4503 11.0283 13.4527 11.0226 13.4531C11.02 13.4533 11.0176 13.4528 11.0148 13.4521C11.0121 13.4516 11.0057 13.4497 10.9962 13.4443L7.90247 11.709C7.4314 11.4447 6.85693 11.4447 6.38586 11.709L3.29504 13.4434C3.28546 13.4487 3.27914 13.4506 3.27649 13.4512C3.27376 13.4518 3.27113 13.4513 3.26868 13.4512C3.26294 13.4507 3.25246 13.4483 3.24133 13.4404C3.2303 13.4326 3.22412 13.4241 3.2218 13.4189C3.22077 13.4166 3.22022 13.414 3.21985 13.4111C3.2195 13.4084 3.21908 13.4022 3.22083 13.3916L3.84094 9.67871C3.9221 9.19261 3.76735 8.69723 3.42395 8.34375L0.764771 5.60645C0.752909 5.59414 0.751704 5.58692 0.751099 5.58398C0.749953 5.57817 0.748977 5.56779 0.753052 5.55566C0.75719 5.54351 0.764272 5.53608 0.768677 5.53223C0.770984 5.53021 0.776167 5.52508 0.793091 5.52246L4.38879 4.97363C4.90139 4.89523 5.34086 4.56585 5.55969 4.0957L7.10364 0.77832C7.1083 0.768417 7.11262 0.763682 7.11438 0.761719C7.11625 0.759665 7.11816 0.7581 7.12024 0.756836C7.12512 0.753931 7.13476 0.750053 7.14856 0.75C7.16263 0.749965 7.17303 0.753931 7.17786 0.756836Z"
                            stroke="var(--ui-content-secondary)"
                            strokeWidth="1.5"
                            strokeLinejoin="round"
                        />
                    </svg>
                )}
        </div>
    );
};
